import { render, staticRenderFns } from "./TransactionHistoryListingCard.vue?vue&type=template&id=bf06cd74&"
import script from "./TransactionHistoryListingCard.vue?vue&type=script&lang=js&"
export * from "./TransactionHistoryListingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports